import Toast, {
  displayToast, displayPromiseToast, displayErrorToast, dismissToast, displayInfoToast,
} from './Toast';

export {
  displayToast, displayPromiseToast, displayErrorToast, dismissToast, displayInfoToast,
};
export default Toast;
